<template>
<div>
    <div class="pa-3 confirm_cart_footer">
        <v-btn width="100%" height="55" class="titlefont_cart_footer d-flex justify-space-between white--text" :style="{background: bg_color}" @click="$router.push('/cartmenu/'+ cart_type+'/'+$route.params.token)" v-if="$route.name == 'buffetUser' && cart_type && $store.state.cartListUser.length > 0 || $route.name == 'singleDishMealUser' && cart_type && $store.state.cartListUser.length > 0">
            <div>
                <div class="cart_number_footer" :style="{color: bg_color}">
                    {{ $store.state.cartListUser.length }}
                </div>
            </div>
            <div>
                {{ $t('viewCart') }}
            </div>
            <div>
                {{ Intl.NumberFormat().format($store.state.cartListUser.reduce((sum,number) => { return sum + number.total_price + (number.toppingprice * number.amount)}, 0)) }} ฿
            </div>
        </v-btn>

        <v-btn width="100%" height="55" class="titlefont_cart_footer d-flex justify-space-between white--text" :style="{background: bg_color}" @click="$router.push('/carttakeouttable/'+$route.params.token)" v-if="$route.name == 'takeOutUserTable' && $store.state.cartListTakeOutTable.length > 0">
            <div>
                <div class="cart_number_footer" :style="{color: bg_color}">
                    {{ $store.state.cartListTakeOutTable.length }}
                </div>
            </div>
            <div>
                {{ $t('viewCart') }}
            </div>
            <div>
                {{ Intl.NumberFormat().format($store.state.cartListTakeOutTable.reduce((sum,number) => { return sum + number.total_price + (number.toppingprice * number.amount)}, 0)) }} ฿
            </div>
        </v-btn>

        <v-btn width="100%" height="55" class="titlefont_cart_footer d-flex justify-space-between white--text" :style="{background: bg_color}" @click="$router.push('/carttakeoutuser')" v-if="$route.name == 'takeOutUser' && $store.state.cartListUserTakeOut.length > 0">
            <div>
                <div class="cart_number_footer" :style="{color: bg_color}">
                    {{ $store.state.cartListUserTakeOut.length }}
                </div>
            </div>
            <div>
                {{ $t('viewCart') }}
            </div>
            <div>
                {{ Intl.NumberFormat().format($store.state.cartListUserTakeOut.reduce((sum,number) => { return sum + number.total_price + (number.toppingprice * number.amount)}, 0)) }} ฿
            </div>
        </v-btn>

        <v-btn width="100%" height="55" class="titlefont_cart_footer d-flex justify-space-between white--text" :style="{background: bg_color}" @click="$router.push('/cartorderonlinepickup')" v-if="$route.name == 'orderOnlinePickUp' && $store.state.cartListUserOrderOnline.length > 0">
            <div>
                <div class="cart_number_footer" :style="{color: bg_color}">
                    {{ $store.state.cartListUserOrderOnline.length }}
                </div>
            </div>
            <div>
                {{ $t('viewCart') }}
            </div>
            <div>
                {{ Intl.NumberFormat().format($store.state.cartListUserOrderOnline.reduce((sum,number) => { return sum + number.total_price + (number.toppingprice * number.amount)}, 0)) }} ฿
            </div>
        </v-btn>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store'; // นำเข้า Vuex store
Vue.use(VueI18n);
const messages = {
    en: {
    viewCart: 'View Cart',
    cart: 'Cart',
    total: 'Total',
    cartItems: 'Items in Cart'
  },
  th: {
    viewCart: 'ดูของในตระกร้า',
    cart: 'ตระกร้า',
    total: 'รวม',
    cartItems: 'รายการในตะกร้า'
  }
};
const i18n = new VueI18n({
  locale: store.state.lang, // กำหนดภาษาหลัก
  messages,
});
export default {
    i18n,
    data() {
        return {
            bg_color: 'linear-gradient(to top, #038cc1 , #55c0e9)',
            title: this.$route.name == 'buffetUser' ? 'buffet' : 'alacarte',
            cart_type: null,
        }
    },
    methods: {
        async colorRestaurant() {
            HTTP.get('/showColor')
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        this.$router.push('/nametakeoutuser')
                    }

                })
        },
    },
    mounted() {
        this.colorRestaurant()

    },
    props: ['table_type'],
    watch: {
        table_type: function (val) {
            if (val === 'บุฟเฟ่') {
                this.cart_type = 'buffetuser/' + this.$route.params.id
            }
            if (val === 'ไม่บุฟเฟ่') {
                this.cart_type = 'singledishmealuser/' + this.$route.params.id
            }
            if (val === 'takeoutuser') {
                this.cart_type = 'takeoutuser/home'
            }
            if (val === 'orderonlinepickup') {
                this.cart_type = 'orderonlinepickup/home'
            }
        }
    }
}
</script>

<style scoped>
.confirm_cart_footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    background: #fff;
}

.titlefont_cart_footer {
    font-size: 22px !important;
}

.color_btn {
    background: linear-gradient(to top, #038cc1, #55c0e9) !important;
}

.cart_number_footer {
    border-radius: 50%;
    width: 30px;
    text-align: center;
    background: #ffffff;
    color: #038cc1;
}
</style>
